/* @flow */
export default [
  {
    "4": {
      defaultValue: { USD: 60, EUR: 60, VND: 2000, RUB: 3500, HKD: 450 },
      defaultBilling: {
        desktop: "sterling",
        mac_desktop: "sterling",
        mobile: "sterling"
      },
      banksSettings: {
        mustBeSelected: 1,
        forBilling: "help2pay",
        "choose.bank.key": "fill45.choose.offline.billing",
        banks: [
          {
            title_code: "Techcombank",
            img_path: "/img/bank-logo/bank_techcom.png",
            classes: "bank",
            "data-code": "TECHCOM"
          },
          {
            title_code: "Sacombank",
            img_path: "/img/bank-logo/bank_sacom.png",
            classes: "bank",
            "data-code": "SACOM"
          },
          {
            title_code: "Vietcombank",
            img_path: "/img/bank-logo/bank_vietcom.png",
            classes: "bank",
            "data-code": "VIETCOM"
          },
          {
            title_code: "Asia Commercial Bank",
            img_path: "/img/bank-logo/bank_acb.png",
            classes: "bank",
            "data-code": "ACB"
          },
          {
            title_code: "DongA Bank",
            img_path: "/img/bank-logo/bank_donga.png",
            classes: "bank",
            "data-code": "DONG_A"
          },
          {
            title_code: "Vietinbank",
            img_path: "/img/bank-logo/bank_vietin.png",
            classes: "bank",
            "data-code": "VIETIN"
          },
          {
            title_code: "BIDV Bank",
            img_path: "/img/bank-logo/bank_bidv.png",
            classes: "bank",
            "data-code": "BIDV"
          },
          {
            title_code: "Eximbank Vietnam",
            img_path: "/img/bank-logo/bank_exim.png",
            classes: "bank",
            "data-code": "EXIM"
          }
        ]
      },
      billings: {
        sterling: {
          allowedCurrencies: ["VND", "USD", "HKD"],
          allowedPlatforms: ["desktop", "mac_desktop", "mobile"],
          id: "sterling",
          inputValue: "sterling::sterling",
          bonus: 10,
          title_key: "billing.type.cc",
          typeImage: {
            path: "/img/billing/types/card_type.png",
            classes: "cardIcon"
          },
          paymentImages: [
            { path: "/img/visa.png", classes: "visa" },
            { path: "/img/mastercard.png", classes: "mastercard" }
          ],
          tooltips: { txtKey: "fillup.cc.tooltip" }
        },
        baokim: {
          allowedCurrencies: ["VND"],
          allowedPlatforms: ["desktop", "mac_desktop", "mobile"],
          id: "baokim",
          bonus: 0,
          inputValue: "baokim::baokim",
          title_key: "billing.type.local.vietnam.banks",
          typeImage: {
            path: "/img/billing/types/bank_type.png",
            classses: "baokim"
          },
          paymentImages: [{ path: "/img/billing/baokim2.png" }],
          needsFullName: true,
          needsPhoneNumber: true
        },
        offline: {
          allowedCurrencies: ["VND"],
          allowedPlatforms: ["desktop", "mac_desktop", "mobile"],
          id: "offlineBanking",
          inputValue: "offline_wire_transfer",
          bonus: 0,
          title_key: "billing.type.offline.banking",
          typeImage: {
            path: "/img/billing/types/offline_type.png",
            classes: "offlineIcon"
          },
          paymentImages: [
            { path: "/img/billing/bank_types/vietcom_bank.png", classes: "" },
            { path: "/img/billing/bank_types/vietin_bank.png", classes: "" },
            { path: "/img/billing/bank_types/exim_bank.png", classes: "" }
          ],
          tooltips: { txtKey: "fillup.offline.banking.tooltip" },
          offlineContinueSection: false
        },
        atm: {
          allowedCurrencies: ["USD", "VND", "RUB"],
          allowedPlatforms: ["desktop", "mac_desktop", "mobile"],
          id: "atmBanking",
          inputValue: "atm",
          bonus: 0,
          title_key: "billing.type.atm.banking",
          typeImage: {
            path: "/img/billing/types/atm_type.png",
            classes: "atmIcon"
          },
          paymentImages: [
            { path: "/img/billing/bank_types/donga_bank.png", classes: "" },
            { path: "/img/billing/bank_types/acb_bank.png", classes: "acb" },
            {
              path: "/img/billing/bank_types/fillup_vietcom_bank.png",
              classes: ""
            }
          ],
          tooltips: { txtKey: "fillup.offline.atm.tooltip" },
          offlineContinueSection: false
        },
        help2pay: {
          allowedCurrencies: ["VND"],
          allowedPlatforms: ["desktop", "mac_desktop", "mobile"],
          id: "help2pay",
          bonus: 0,
          inputValue: "help2pay::help2pay",
          title_key: "billing.type.online.banks",
          typeImage: { path: "/img/billing/types/online_type.png" },
          tooltips: { txtKey: "fillup.online.banking.tooltip" },
          paymentImages: [{ path: "/img/billing/bank-types.png" }]
        }
      },
      deposits: {
        default: {
          USD: [
            { amount: 900, bonus: 50, vip: 1 },
            { amount: 400, bonus: 33, vip: 0 },
            { amount: 200, bonus: 30, vip: 0 },
            { amount: 100, bonus: 25, vip: 0 },
            { amount: 90, bonus: 17, vip: 0 },
            { amount: 60, bonus: 12, vip: 0 },
            { amount: 30, bonus: 10, vip: 0 },
            { amount: 20, bonus: 0, vip: 0 }
          ],
          EUR: [
            { amount: 900, bonus: 50, vip: 1 },
            { amount: 400, bonus: 33, vip: 0 },
            { amount: 200, bonus: 30, vip: 0 },
            { amount: 100, bonus: 25, vip: 0 },
            { amount: 90, bonus: 17, vip: 0 },
            { amount: 60, bonus: 12, vip: 0 },
            { amount: 30, bonus: 10, vip: 0 },
            { amount: 10, bonus: 0, vip: 0 }
          ],
          RUB: [
            { amount: 52000, bonus: 50, vip: 1 },
            { amount: 26000, bonus: 33, vip: 0 },
            { amount: 12000, bonus: 30, vip: 0 },
            { amount: 7000, bonus: 25, vip: 0 },
            { amount: 3500, bonus: 17, vip: 0 },
            { amount: 1800, bonus: 12, vip: 0 },
            { amount: 1300, bonus: 10, vip: 0 },
            { amount: 700, bonus: 0, vip: 0 }
          ],
          VND: [
            { amount: 20000, bonus: 50, vip: 1 },
            { amount: 10000, bonus: 33, vip: 0 },
            { amount: 5000, bonus: 30, vip: 0 },
            { amount: 3000, bonus: 25, vip: 0 },
            { amount: 2000, bonus: 17, vip: 0 },
            { amount: 1500, bonus: 12, vip: 0 },
            { amount: 700, bonus: 10, vip: 0 },
            { amount: 250, bonus: 0, vip: 0 }
          ],
          HKD: [
            { amount: 7000, bonus: 50, vip: 1 },
            { amount: 3000, bonus: 33, vip: 0 },
            { amount: 1500, bonus: 30, vip: 0 },
            { amount: 1000, bonus: 25, vip: 0 },
            { amount: 700, bonus: 17, vip: 0 },
            { amount: 450, bonus: 12, vip: 0 },
            { amount: 200, bonus: 10, vip: 0 },
            { amount: 100, bonus: 0, vip: 0 }
          ]
        }
      }
    }
  },
  {
    "11": {
      defaultValue: { USD: 60, EUR: 60, VND: 2000, RUB: 3500, HKD: 450 },
      defaultBilling: {
        desktop: "sterling",
        mac_desktop: "sterling",
        mobile: "sterling"
      },
      banksSettings: {
        mustBeSelected: 1,
        forBilling: "help2pay",
        "choose.bank.key": "fill45.choose.offline.billing",
        banks: [
          {
            title_code: "Techcombank",
            img_path: "/img/bank-logo/bank_techcom.png",
            classes: "bank",
            "data-code": "TECHCOM"
          },
          {
            title_code: "Sacombank",
            img_path: "/img/bank-logo/bank_sacom.png",
            classes: "bank",
            "data-code": "SACOM"
          },
          {
            title_code: "Vietcombank",
            img_path: "/img/bank-logo/bank_vietcom.png",
            classes: "bank",
            "data-code": "VIETCOM"
          },
          {
            title_code: "Asia Commercial Bank",
            img_path: "/img/bank-logo/bank_acb.png",
            classes: "bank",
            "data-code": "ACB"
          },
          {
            title_code: "DongA Bank",
            img_path: "/img/bank-logo/bank_donga.png",
            classes: "bank",
            "data-code": "DONG_A"
          },
          {
            title_code: "Vietinbank",
            img_path: "/img/bank-logo/bank_vietin.png",
            classes: "bank",
            "data-code": "VIETIN"
          },
          {
            title_code: "BIDV Bank",
            img_path: "/img/bank-logo/bank_bidv.png",
            classes: "bank",
            "data-code": "BIDV"
          },
          {
            title_code: "Eximbank Vietnam",
            img_path: "/img/bank-logo/bank_exim.png",
            classes: "bank",
            "data-code": "EXIM"
          }
        ]
      },
      billings: {
        sterling: {
          allowedCurrencies: ["VND", "USD", "HKD"],
          allowedPlatforms: ["desktop", "mac_desktop", "mobile"],
          id: "sterling",
          inputValue: "sterling::sterling",
          bonus: 10,
          title_key: "billing.type.cc",
          typeImage: {
            path: "/img/billing/types/card_type.png",
            classes: "cardIcon"
          },
          paymentImages: [
            { path: "/img/visa.png", classes: "visa" },
            { path: "/img/mastercard.png", classes: "mastercard" }
          ],
          tooltips: { txtKey: "fillup.cc.tooltip" }
        },
        baokim: {
          allowedCurrencies: ["VND"],
          allowedPlatforms: ["desktop", "mac_desktop", "mobile"],
          id: "baokim",
          bonus: 0,
          inputValue: "baokim::baokim",
          title_key: "billing.type.local.vietnam.banks",
          typeImage: {
            path: "/img/billing/types/bank_type.png",
            classses: "baokim"
          },
          paymentImages: [{ path: "/img/billing/baokim2.png" }],
          needsFullName: true,
          needsPhoneNumber: true
        },
        offline: {
          allowedCurrencies: ["VND"],
          allowedPlatforms: ["desktop", "mac_desktop", "mobile"],
          id: "offlineBanking",
          inputValue: "offline_wire_transfer",
          bonus: 0,
          title_key: "billing.type.offline.banking",
          typeImage: {
            path: "/img/billing/types/offline_type.png",
            classes: "offlineIcon"
          },
          paymentImages: [
            { path: "/img/billing/bank_types/vietcom_bank.png", classes: "" },
            { path: "/img/billing/bank_types/vietin_bank.png", classes: "" },
            { path: "/img/billing/bank_types/exim_bank.png", classes: "" }
          ],
          tooltips: { txtKey: "fillup.offline.banking.tooltip" },
          offlineContinueSection: false
        },
        atm: {
          allowedCurrencies: ["USD", "VND", "RUB"],
          allowedPlatforms: ["desktop", "mac_desktop", "mobile"],
          id: "atmBanking",
          inputValue: "atm",
          bonus: 0,
          title_key: "billing.type.atm.banking",
          typeImage: {
            path: "/img/billing/types/atm_type.png",
            classes: "atmIcon"
          },
          paymentImages: [
            { path: "/img/billing/bank_types/donga_bank.png", classes: "" },
            { path: "/img/billing/bank_types/acb_bank.png", classes: "acb" },
            {
              path: "/img/billing/bank_types/fillup_vietcom_bank.png",
              classes: ""
            }
          ],
          tooltips: { txtKey: "fillup.offline.atm.tooltip" },
          offlineContinueSection: false
        },
        help2pay: {
          allowedCurrencies: ["VND"],
          allowedPlatforms: ["desktop", "mac_desktop", "mobile"],
          id: "help2pay",
          bonus: 0,
          inputValue: "help2pay::help2pay",
          title_key: "billing.type.online.banks",
          typeImage: { path: "/img/billing/types/online_type.png" },
          tooltips: { txtKey: "fillup.online.banking.tooltip" },
          paymentImages: [{ path: "/img/billing/bank-types.png" }]
        }
      },
      deposits: {
        default: {
          USD: [
            { amount: 900, bonus: 50, vip: 1 },
            { amount: 400, bonus: 33, vip: 0 },
            { amount: 200, bonus: 30, vip: 0 },
            { amount: 100, bonus: 25, vip: 0 },
            { amount: 90, bonus: 17, vip: 0 },
            { amount: 60, bonus: 12, vip: 0 },
            { amount: 30, bonus: 10, vip: 0 },
            { amount: 20, bonus: 0, vip: 0 }
          ],
          EUR: [
            { amount: 900, bonus: 50, vip: 1 },
            { amount: 400, bonus: 33, vip: 0 },
            { amount: 200, bonus: 30, vip: 0 },
            { amount: 100, bonus: 25, vip: 0 },
            { amount: 90, bonus: 17, vip: 0 },
            { amount: 60, bonus: 12, vip: 0 },
            { amount: 30, bonus: 10, vip: 0 },
            { amount: 10, bonus: 0, vip: 0 }
          ],
          RUB: [
            { amount: 52000, bonus: 50, vip: 1 },
            { amount: 26000, bonus: 33, vip: 0 },
            { amount: 12000, bonus: 30, vip: 0 },
            { amount: 7000, bonus: 25, vip: 0 },
            { amount: 3500, bonus: 17, vip: 0 },
            { amount: 1800, bonus: 12, vip: 0 },
            { amount: 1300, bonus: 10, vip: 0 },
            { amount: 700, bonus: 0, vip: 0 }
          ],
          VND: [
            { amount: 20000, bonus: 50, vip: 1 },
            { amount: 10000, bonus: 33, vip: 0 },
            { amount: 5000, bonus: 30, vip: 0 },
            { amount: 3000, bonus: 25, vip: 0 },
            { amount: 2000, bonus: 17, vip: 0 },
            { amount: 1500, bonus: 12, vip: 0 },
            { amount: 700, bonus: 10, vip: 0 },
            { amount: 250, bonus: 0, vip: 0 }
          ],
          HKD: [
            { amount: 7000, bonus: 50, vip: 1 },
            { amount: 3000, bonus: 33, vip: 0 },
            { amount: 1500, bonus: 30, vip: 0 },
            { amount: 1000, bonus: 25, vip: 0 },
            { amount: 700, bonus: 17, vip: 0 },
            { amount: 450, bonus: 12, vip: 0 },
            { amount: 200, bonus: 10, vip: 0 },
            { amount: 100, bonus: 0, vip: 0 }
          ]
        }
      }
    }
  }
];



// WEBPACK FOOTER //
// ./src/configs/FillupConfig_default.js